import { Grid } from '@mui/material';
import React, { useState } from 'react';
import { CustomCellProps } from 'components/common/grid/';
import useBundleTranslation from 'i18n';
import ReportAlertRuleWizard from 'app/report/report-alert-rule-wizard/ReportAlertRuleWizard';

export default function EditReportAlertRuleCell({
    t,
    elementId,
    alertRuleId,
    text,
}: CustomCellProps & { elementId: number; alertRuleId: number }) {
    if (undefined === t) t = useBundleTranslation('main')['t'];
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <Grid container>
            <span className={'default-link'} onClick={() => setIsPopupOpen(true)}>
                {text}
            </span>
            {isPopupOpen && (
                <ReportAlertRuleWizard
                    elementId={elementId}
                    alertRuleId={alertRuleId}
                    isOpen={isPopupOpen}
                    setIsOpen={setIsPopupOpen}
                />
            )}
        </Grid>
    );
}
